import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.rego = bracketIndenting({
	line: "#",
})
